// 导入封装好的 axios 实例
import request from '@/utils/request'

export function findByEquipmentId(params) {
    return request({
        url: '/program/equipment/emergency/contact/find',
        method: 'get',
        params
    })
}

export function saveOrUpdate(data) {
    return request({
        url: '/program/equipment/emergency/contact',
        method: 'post',
        data
    })
}
export function deleteById(data) {
    return request({
        url: '/program/equipment/emergency/contact/delete',
        method: 'delete',
        data
    })
}
